export default ["M10 3a7 7 0 100 14 7 7 0 100-14z"];
//# sourceMappingURL=record.js.map